import { TargetCheckTypeNew } from '@nkr/enums/target-check-type';

export interface IMatchRunGroup {
    id: number,
    name: string,
    stalled: boolean,
    loops: boolean,
    specialSort: boolean,
    checkType: TargetCheckTypeNew,
    cssClass: string,
    visible: boolean,
    sortOrder: number,
    future: boolean
}

export interface IMatchRunScenario {
    id: number,
    title: string,
    group: IMatchRunGroup,
    restricted: number,
    stalled: boolean,
    loops: boolean,
    submit: boolean
}
